import { getStore } from '../../store'

export default function doFetch(url, options = {}) {
  const jwt = getStore().getState().auth.jwt
  if (jwt) {
    options.headers = {
      ...options.headers,
      Authorization: `Bearer ${jwt}`,
    }
  }
  return fetch(url, options)
}



// WEBPACK FOOTER //
// ./src/modules/portal-remote/doFetch.js